const routerArr = [
  {
      path: '/testpage',
      name: 'testpage',
      meta: { title:'测评' ,login:true},
      component: () => import(/* webpackChunkName: 'coursetest' */ './page/testpage.vue'),
  },
  {
    path: '/testresults',
    name: 'testresults',
    meta: { title:'测评作答页' ,login:true},
    component: () => import(/* webpackChunkName: 'coursetest' */ './page/testresults.vue'),
  }
]
export default routerArr